// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/

export let SegmentEventTypes = /*#__PURE__*/function (SegmentEventTypes) {
  SegmentEventTypes["IDENTIFY"] = "identify";
  SegmentEventTypes["PAGE"] = "page";
  // Dont need Screen as page and screen are the same and we only use page
  SegmentEventTypes["TRACK"] = "track";
  return SegmentEventTypes;
}({});
export let CrossDomainIdentifierType = /*#__PURE__*/function (CrossDomainIdentifierType) {
  CrossDomainIdentifierType["XC"] = "xc";
  CrossDomainIdentifierType["UID"] = "uid";
  return CrossDomainIdentifierType;
}({});
export let CrossDomainIdentifierState = /*#__PURE__*/function (CrossDomainIdentifierState) {
  CrossDomainIdentifierState["NEW"] = "NEW";
  CrossDomainIdentifierState["CHANGED"] = "CHANGED";
  CrossDomainIdentifierState["EXISTING"] = "EXISTING";
  CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
  CrossDomainIdentifierState["ERROR"] = "ERROR";
  CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
  CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
  CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
  return CrossDomainIdentifierState;
}({});
export class MetadataResponse {
  constructor(props, url) {
    this.props = props;
    this.url = url;
  }
  static fromJson(json) {
    let isString = value => typeof value === 'string' || value instanceof String;
    const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
    return new MetadataResponse((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
  }
}
;
export class FetchError extends Error {
  constructor(message, statusCode, statusText) {
    super(message);
    this.statusCode = statusCode;
    this.statusText = statusText;
  }
}
export const ALLOW_LISTED_FETCH_ERROR_NAMES = ['FetchError', 'AbortError', 'TypeError'];